import { getQueryStringParams, setQueryStringParam } from "../../shared/utils";

export function workflowOverviewTabs() {
  // Initialize from URL param or default to 'average'
  const initialSection =
    getQueryStringParams().get("overview_section") || "average";

  return {
    selectedSection: initialSection,

    init() {
      // Re-render charts for initial section after DOM is ready
      this.$nextTick(() => {
        this.renderChartsForSection(this.selectedSection);
      });
    },

    get compareTo() {
      return this.$store.snapshotResultFilters.compareTo;
    },

    renderChartsForSection(section) {
      // Re-render charts when section becomes visible
      // Dispatch event to parent component to trigger chart rendering
      this.$nextTick(() => {
        this.$dispatch("render-overview-charts", { section });
      });
    },

    selectSection(section) {
      this.selectedSection = section;
      setQueryStringParam("overview_section", section);
      this.renderChartsForSection(section);
    },

    calculateWorkflowComparison() {
      if (this.compareTo == "vs_50th") {
        return this.selectedWorkflow.avg_value_percent_diff_50 ?? null;
      } else if (this.compareTo == "vs_75th") {
        return this.selectedWorkflow.avg_value_percent_diff_75 ?? null;
      } else if (this.compareTo == "vs_90th") {
        return this.selectedWorkflow.avg_value_percent_diff_90 ?? null;
      } else if (this.compareTo == "vs_prev") {
        return this.selectedWorkflow.avg_value_percent_diff_prev ?? null;
      } else if (this.compareTo == "vs_org") {
        return this.selectedWorkflow.avg_value_percent_diff_org ?? null;
      }
    },

    calculateAnnualizedCostComparison() {
      const WORK_WEEKS_PER_YEAR = 48;
      const annualizedCost =
        this.selectedWorkflow?.annualized_time_cost_per_engineer;

      if (!annualizedCost) return null;

      let benchmark;
      if (this.compareTo == "vs_50th") {
        benchmark = this.selectedWorkflow.benchmark_50;
      } else if (this.compareTo == "vs_75th") {
        benchmark = this.selectedWorkflow.benchmark_75;
      } else if (this.compareTo == "vs_90th") {
        benchmark = this.selectedWorkflow.benchmark_90;
      } else if (this.compareTo == "vs_prev") {
        // Previous annualized cost not currently available
        return null;
      } else if (this.compareTo == "vs_org") {
        // Calculate org annualized cost
        const orgAvgValue = this.selectedWorkflow.org_avg_value;
        if (orgAvgValue) {
          const annualizedOrgCost = orgAvgValue * WORK_WEEKS_PER_YEAR;
          return Math.round(
            ((annualizedCost - annualizedOrgCost) / annualizedOrgCost) * 100,
          );
        }
        return null;
      }

      if (!benchmark) return null;

      const annualizedBenchmark = benchmark * WORK_WEEKS_PER_YEAR;
      return Math.round(
        ((annualizedCost - annualizedBenchmark) / annualizedBenchmark) * 100,
      );
    },

    compareToLabel() {
      if (this.compareTo == "vs_50th") {
        return "vs Industry P50";
      } else if (this.compareTo == "vs_75th") {
        return "vs Industry P75";
      } else if (this.compareTo == "vs_90th") {
        return "vs Industry P90";
      } else if (this.compareTo == "vs_prev") {
        return "vs Previous";
      } else if (this.compareTo == "vs_org") {
        return "vs Organization";
      }
      return "";
    },
  };
}
